uniform sampler2D diffuseTexture;
uniform samplerCube envMap;
uniform float alphaExponent;
varying vec2 vUV;

void main() {
	vec3 texture_color = texture2D(diffuseTexture, vUV * 2.0).rgb;

	gl_FragColor.rgb = texture_color;
	// The brighter a color, the less transparent it becomes. Anything above 2.5 is opaque (~0xb0b0b0)
	gl_FragColor.a = pow((gl_FragColor.r + gl_FragColor.g + gl_FragColor.b) * 0.4, alphaExponent);
}